import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
export class TraitRegistryQuestion extends TraitRegistryCategory {
    label = 'Question';
    constructor(parent) {
        super(parent);
        super.init();
    }
    feedbackTime = () => new TraitTypeNumeric({
        // label: 'Feedbackzeit in ms',
        default: 3000
        //  min: 0,
        //  max: 10000
    });
}
